export const SINGLE_PAGE_REQUEST_PREFILL_STORAGE_KEY = 'lz_single_page_request_prefill_payload'

export type SinglePageRequestPrefillPayload = Record<string, unknown>

export const setSinglePageRequestPrefillPayload = (
	payload: SinglePageRequestPrefillPayload
) => {
	sessionStorage.setItem(
		SINGLE_PAGE_REQUEST_PREFILL_STORAGE_KEY,
		JSON.stringify(payload || {})
	)
}

export const consumeSinglePageRequestPrefillPayload =
	(): SinglePageRequestPrefillPayload | null => {
		const rawPayload = sessionStorage.getItem(SINGLE_PAGE_REQUEST_PREFILL_STORAGE_KEY)
		if (!rawPayload) return null

		sessionStorage.removeItem(SINGLE_PAGE_REQUEST_PREFILL_STORAGE_KEY)

		try {
			const parsedPayload = JSON.parse(rawPayload)
			if (!parsedPayload || typeof parsedPayload !== 'object') return null

			return parsedPayload as SinglePageRequestPrefillPayload
		} catch {
			return null
		}
	}
